import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';
import './SessionHistoryTable.css'; // Create this new CSS file

const SessionHistoryTable = ({ sessions, sessionRegistrationCounts, countries, cities, completedSessionsCount, allUsers }) => {
  const { i18n } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSessionUsers, setSelectedSessionUsers] = useState([]);
  const [selectedSessionTitle, setSelectedSessionTitle] = useState('');

  if (!sessions || sessions.length === 0) {
    return <p>Aucune session terminée disponible pour le moment.</p>;
  }

  const handleRowClick = (session) => {
    if (!allUsers) return;
    const usersForSession = allUsers.filter(user => 
      user.sessionIds && user.sessionIds.includes(session.id)
    );
    setSelectedSessionUsers(usersForSession);
    setSelectedSessionTitle(session.title);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedSessionUsers([]);
    setSelectedSessionTitle('');
  };

  return (
    <div className="session-history-table-container">
      <h3>Historique des Sessions ({completedSessionsCount})</h3>
      <p className="table-instruction">Cliquez sur une ligne pour voir les inscrits.</p>
      <table>
        <thead>
          <tr>
            <th>Titre</th>
            <th>Ville</th>
            <th>Adresse</th>
            <th>Langue</th>
            <th>Date</th>
            <th>Heure de Début</th>
            <th>Heure de Fin</th>
            <th>Inscrits</th>
          </tr>
        </thead>
        <tbody>
          {[...sessions].sort((a, b) => new Date(b.startTime) - new Date(a.startTime)).map(session => {
            const city = cities.find(c => c.id === session.cityId);
            const registrationCount = sessionRegistrationCounts[session.id]?.totalCount || 0;

            return (
              <tr key={session.id} onClick={() => handleRowClick(session)} className="clickable-row">
                <td>{session.title}</td>
                <td>{city ? city.name[i18n.language.split('-')[0]] : 'N/A'}</td>
                <td>{session.address}</td>
                <td>{session.language}</td>
                <td>{new Date(session.startTime).toLocaleDateString(i18n.language)}</td>
                <td>{new Date(session.startTime).toLocaleTimeString(i18n.language)}</td>
                <td>{new Date(session.endTime).toLocaleTimeString(i18n.language)}</td>
                <td>{registrationCount}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Inscrits pour: {selectedSessionTitle}</h2>
            <button onClick={closeModal} className="modal-close-button"><FaTimes /></button>
            <div className="user-list-table-container">
              {selectedSessionUsers.length > 0 ? (
                <table>
                  <thead>
                    <tr>
                      <th>Prénom</th>
                      <th>Nom</th>
                      <th>Email</th>
                      <th>Téléphone</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedSessionUsers.map(user => (
                      <tr key={user.id}>
                        <td>{user.firstName}</td>
                        <td>{user.lastName}</td>
                        <td>{user.email}</td>
                        <td>{user.phoneNumber}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>Aucun utilisateur inscrit pour cette session.</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SessionHistoryTable;